import apiAthlete from '@/api/athlete'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteAthleteStart: '[delete athlete] Delete athlete start',
  deleteAthleteSuccess: '[delete athlete] Delete athlete success',
  deleteAthleteFailure: '[delete athlete] Delete athlete failure'
}

export const actionTypes = {
  deleteAthlete: '[delete athlete] Delete athlete'
}

const mutations = {
  [mutationTypes.deleteAthleteStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteAthleteSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteAthleteFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteAthlete](context, {id}) {
    context.commit(mutationTypes.deleteAthleteStart)
    return new Promise(resolve => {
      apiAthlete
        .deleteAthlete(id)
        .then(response => {
          context.commit(mutationTypes.deleteAthleteSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteAthleteFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
